export default "__VITE_ASSET__df08ee8d__"